import { Space, Workspace } from '../mainApi';

export class WorkspaceUtils {
  static workspaceNameFromSpace(
    space: Space | null,
    workspaces: Workspace[],
    selectedWorkspace: Workspace | null
  ): string | null {
    if (!space?.workspace) {
      return selectedWorkspace?.title ?? null;
    }

    const matchedWorkspace = workspaces.find((workspace) => workspace.id === String(space.workspace));
    if (matchedWorkspace?.title) {
      return matchedWorkspace.title;
    }

    return typeof space.workspace === 'string' ? space.workspace : null;
  }
}
